<template>
    <div class="w-100 h-100 mobile-public-signin" v-show="ready">
        <div class="page-header">
            <div class="page-container">
                <div class="logo justify-content-center" >
                    <img class="" :src="logo" alt="university-logo" style="height: 54px;">
                </div>
            </div>
        </div>
        <div class="page-body">
            <el-carousel indicator-position="inside" height="493px">
                <el-carousel-item v-for="item in background_images" :key="item">
                    <div class="carousel-image" :style="{'background-image':'url('+'assets/images/'+item+')'}"></div>
                </el-carousel-item>
            </el-carousel>
            <div class="body-wrap">
                <div class="login page-container">
                    <div class="login-wrap">
                        <div class="login-bg">
                            <div class="login-table">
                                <div class="text-center login-title">
                                    登 录 | SIGN IN
                                </div>
                                <div class="line"></div>
                                <form class="clearfix" action="/" @submit.prevent="submitForm" v-if="admin_login">
                                    <div class="login-group">
                                        <div class="login-input-wrap">
                                            <input type="text" v-model="login.id"
                                                   placeholder="用户/邮箱" class="login-input" required>
                                        </div>
                                    </div>

                                    <div class="login-group mt-2">
                                        <div class="login-input-wrap">
                                            <input type="password" v-model="login.password"
                                                   placeholder="密码" class="login-input" required>
                                        </div>
                                    </div>

                                    <div>
                                        <button type="submit" class="login-btn btn btn-block" :disable="process.loading"
                                                style="font-size:20px;">登 录
                                        </button>
                                    </div>

                                    <div class="text-right text-muted mt-2">
                                        <div class="pull-left">
                                            <el-button type="text" @click="admin_login=false" style="height: 48px;padding-top: 15px;">
                                                <i class="el-icon-user-solid"></i> 跨校认证登录
                                            </el-button>
                                        </div>
                                        <div style="height: 48px;padding-top: 15px;">
                                            <a href="javascript:void(0);" @click="resetPassword">
                                                <small >忘记密码?</small>
                                            </a>
                                        </div>
                                    </div>
                                </form>
                                <div v-if="!admin_login" class="flex-in-middle" style="height: 220px;">
                                    <div class="" style="height: 1px"></div>
                                    <div class="w-100">
                                        <button type="button" class="login-btn btn btn-block" :disable="process.loading"
                                                @click="jumpToOAuth2" style="font-size:18px;"> 跨校认证登录
                                        </button>
                                        <div style="font-size:13px;text-align: center;margin-top: 20px;"
                                             class="text-muted">点击按键,跳转到 <b>跨校认证登录</b>
                                        </div>
                                    </div>
                                    <div class="w-100 text-center">
                                        <el-button type="text" @click="admin_login=true"> <i class="el-icon-user-solid"></i> 用户口令登录</el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="page-footer">
            <page-footer></page-footer>
        </div>
        <el-dialog append-to-body width="50%" title="错误" :visible.sync="show_login_error"
                   :close-on-click-modal="false" v-mobile-dialog>

            <el-row :gutter="20">
                <el-col :span="24">
                    <div v-html="error_message"></div>
                </el-col>
            </el-row>
            <div slot="footer" class="">
                <el-button type="primary" @click="jumpToSignIn">关 闭</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex";
    import OauthMixin from "../../common/mixins/oauth-mixins"
    import Cookie from "vuecookie";
    import PageFooter from "../../components/page-footer";
    import QywxCommon from "@/common/mixins/qywxCommon";

    let vm = null;

    export default {
        name: "sign-in",
        components: {PageFooter},
        mixins:[OauthMixin,QywxCommon],
        data() {
            return {
                ready:false,
                admin_login: false,
                background_images: [
                    'tsi-ad-banner-0.jpg','tsi-ad-banner-1.jpg','tsi-ad-banner-2.jpg'
                ],
                login: {
                    id: '',
                    password: ''
                },
                org:this.$organization.org,
                logo: './assets/'+this.$organization.org+'/images/default-logo.png',
                error_message:'error message',
                show_login_error:false,
            }
        },
        created() {
            vm = this;
            let logo = Cookie.get('site-logo');
            if (logo) this.logo = logo;
        },
        computed: {
            ...mapState(['user', 'process']),
        },
        methods: {
            ...mapMutations('user', ['setUserInfo']),
            resetPassword() {
                if (vm.login.id) {
                    vm.$affirm('我们将向您的邮箱发送一份包含有密码的邮件, 是否继续?').then(() => {
                        vm.$api('ResetPassword', vm.login, true).then(() => {
                            vm.$messageBox.success('密码已经发出，请检查您的邮箱。');
                        })
                    })
                } else {
                    vm.$notice.error('请重新输入账号/邮箱');
                }
            },
            submitForm() {
                if (!vm.login.id) {
                    vm.$notice.error('请重新输入账号/邮箱');
                } else {
                    vm.$api('SignIn', vm.login, true).then(response => {
                        vm.setUserInfo(response.data.data);
                        vm.$router.replace("/");
                    });
                }
            },
        },
        mounted(){
            this.ready = false;
            this.qywxHandler();
        },
    }
</script>

<style lang="scss" >
    $--theme-color: #039be5;

    .mobile-public-signin {
        .page-header {

            .logo {
                height: 120px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                flex-direction: row;
            }
        }

        .page-body {
            height: 493px;
            background-color: #d9e3e3;
            position: relative;

            .carousel-image {
                width: 100%;
                height: 493px;
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
            }

            .login {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                z-index: 999;

                .login-wrap {
                    width: 90vw;
                    max-width: 382px;
                    height: 378px;
                    background-color: transparent;
                    position: absolute;
                    top: 46px;
                    right: 15px;
                    border-radius: 8px;
                    padding: 15px;

                    .login-bg {
                        background-color: RGBA(255, 255, 255, 0.75);
                        border-radius: 1px;
                        box-shadow: 0 0 25px #333333;
                        border: 1px solid #cdd9e0;
                        width: 100%;
                        height: 100%;

                        .login-table {
                            width: 270px;
                            margin: auto;

                            .login-title {
                                color: darken($--theme-color,10%);
                                font-size: 26px;
                                padding: 20px;
                            }

                            .line {
                                height: 5px;
                                margin-bottom: 19px;
                                border-bottom: 1px solid $--theme-color;
                            }

                            .login-icon {
                                background: #8c222d;
                                width: 55px;
                                height: 38px;
                                border-radius: 1px;
                                float: left;

                                i {
                                    color: white;
                                    font-size: 26px;
                                    width: 100%;
                                    text-align: center;
                                    line-height: 38px;
                                }
                            }

                            .login-input-wrap {
                                height: 38px;
                                background-color: white;
                                border: 1px solid #ddd;

                                .login-input {
                                    color: #558b2f;
                                    text-indent: 0.2em;
                                    border: none;
                                    outline: none;
                                    height: 36px;
                                    padding-left: 10px;
                                    font-size: 16px;
                                    text-align: center;
                                    width: 100%;
                                }
                            }

                            .login-group {
                                border-radius: 5px;
                                width: 100%;
                                height: 52px;
                                line-height: normal;
                                position: relative;
                            }

                            .login-btn {
                                background-color:  $--theme-color;
                                color: white;
                            }

                            .login-btn:hover {
                                background-color: lighten($--theme-color,10%);
                                color: white;
                            }

                            a {
                                color: #607D8B;

                                &:hover {
                                    color: #8c222d;
                                }
                            }
                        }

                    }
                }
            }
        }

        .page-footer {
            min-height: 87px;
        }

        .flex-in-middle {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: column;
        }
    }

</style>
